module.exports = __webpack_public_path__ + "static/img/GEORGE_BAILEY.0f20888.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GEORGE_BAILEY.jpg
// module id = 4gJ0
// module chunks = 0